module.exports = __webpack_public_path__ + "files/SOS Slide Deck for App.9311e4cc.pptx";